import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

const SCENARIOS = [
  { id: "STANDARD",   labelKey: "scoring.scenario.standard",   hintKey: "scoring.scenario.standardHint" },
  { id: "KO",         labelKey: "scoring.scenario.ko",         hintKey: "scoring.scenario.koHint" },
  { id: "SECOND_LEG", labelKey: "scoring.scenario.secondLeg", hintKey: "scoring.scenario.secondLegHint" },
];

const ScenarioPicker = ({ value, onChange, accent }) => {
  const { t } = useTranslation();

  return (
    <div className="scoring-pick-row scoring-pick-row--scenarios">
      {SCENARIOS.map((s) => {
        const active = value === s.id;
        return (
          <motion.button
            key={s.id}
            type="button"
            className={`scoring-card scoring-card--scenario ${active ? "is-active" : ""}`}
            onClick={() => onChange(s.id)}
            whileHover={{ y: -3 }}
            whileTap={{ scale: 0.97 }}
            style={
              active
                ? {
                    background: `linear-gradient(135deg, ${accent[0]}, ${accent[1]})`,
                    color: "#fff",
                    borderColor: "transparent",
                    boxShadow: `0 8px 20px ${accent[1]}40`,
                  }
                : undefined
            }
          >
            <span className="scoring-card__label">{t(s.labelKey)}</span>
            <span className="scoring-card__hint">{t(s.hintKey)}</span>
          </motion.button>
        );
      })}
    </div>
  );
};

export default ScenarioPicker;
